export var NAME = 'payment';
export var PAYMENT_CURRENCIES_UPDATED = "".concat(NAME, "/PAYMENT_CURRENCIES_UPDATED");
export var PAYMENT_FORM_DATA_UPDATED = "".concat(NAME, "/PAYMENT_FORM_DATA_UPDATED");
export var PAYMENT_LOADED = "".concat(NAME, "/PAYMENT_LOADED");
export var PAYMENT_METHOD_READY = "".concat(NAME, "/PAYMENT_METHOD_READY");
export var PAYMENT_METHOD_REQUESTED = "".concat(NAME, "/PAYMENT_METHOD_REQUESTED");
export var PAYMENT_METHOD_SET = "".concat(NAME, "/PAYMENT_METHOD_SET");
export var SAVE_FAILED = "".concat(NAME, "/SAVE_FAILED");
export var SAVE_REQUESTED = "".concat(NAME, "/SAVE_REQUESTED");